import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentConfig } from '@src/app/configs/environment.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  constructor(
    protected readonly _ENV_CONFIG: EnvironmentConfig,
    private readonly _translateService: TranslateService
  ) {
    // Initialize translations
    this._translateService.setFallbackLang('en');
    console.debug(`Version: V${this._ENV_CONFIG.version}`);
  }
}
